<template>
	<v-chip small class="mb-1 ml-1" color="#f2f2f2" @click="getProductInfo">
		{{product.product.name}} - {{product.frequency[0].morning}} {{product.frequency[0].middle_morning}} {{product.frequency[0].half_day}} {{product.frequency[0].middle_afternoon}} {{product.frequency[0].night}}
		<v-dialog v-model="showProductInfo" max-width="1000" scrollable>
			<v-card>
				<v-card-title class="title primary--text mb-2 secondary" v-translate>Product Info</v-card-title>
				<v-progress-linear
					:active="loadingProductInfo"
					:indeterminate="loadingProductInfo"
					top
					color="primary"
				></v-progress-linear>
				<v-card-text v-if="!loadingProductInfo && type === 'supplement'" class="pt-2">
					<h3 class="primary--text" v-translate>General</h3>
					<v-simple-table>
						<template v-slot:default>
							<thead>
								<tr>
									<th class="text-left" v-translate key="name">Name</th>
									<th class="text-left" v-translate key="provider">Provider</th>
									<th v-if="!product.product.complex_product" class="text-left" v-translate key="unit">Unit</th>
									<th
										v-if="!product.product.complex_product"
										class="text-left"
										v-translate
										key="units"
									>Units p/ box</th>
									<th
										v-if="!product.product.complex_product"
										class="text-left"
										v-translate
										key="presentation"
									>Presentation</th>
									<th
										v-if="!product.product.complex_product"
										class="text-left"
										v-translate
										key="storage"
									>Storage</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>{{ product.product.name }}</td>
									<td>{{ product.product.external_entity.name ? product.product.external_entity.name : '--' }}</td>
									<td v-if="!product.product.complex_product">
										<span
											v-if="product.product.unit"
										>{{ product.product.unit.name }} ({{ product.product.unit.code }})</span>
										<span v-else v-translate>Not defined</span>
									</td>
									<td v-if="!product.product.complex_product">
										<span v-if="product.product.units_box">{{ product.product.units_box }}</span>
										<span v-else v-translate>Not defined</span>
									</td>
									<td v-if="!product.product.complex_product">
										<span v-if="product.product.presentation">{{ product.product.presentation.name }}</span>
										<span v-else v-translate>Not defined</span>
									</td>
									<td v-if="!product.product.complex_product">
										<span v-if="product.product.storage">{{ product.product.storage.name }}</span>
										<span v-else v-translate>Not defined</span>
									</td>
								</tr>
							</tbody>
						</template>
					</v-simple-table>
					<v-row no-gutters>
						<v-col v-if="!product.product.complex_product" cols="12" md="6" class="pr-12">
							<v-row no-gutters class="my-4" justify="center" align="center">
								<h3 class="primary--text" v-translate>Ingredients</h3>
								<v-spacer></v-spacer>
								<span
									v-if="ingredients.length > 0 && product.product.unit"
									class="text-caption"
								>Quantidade por {{product.product.daily_dose}} {{product.product.unit.code}}</span>
							</v-row>
							<p
								v-if="ingredients.length === 0"
								class="font-weight-thin ml-2"
								v-translate
							>No ingredients specified.</p>
							<template v-else>
								<div v-for="(ingredient, index) in ingredients" :key="index">
									<v-list-item dense>
										<v-list-item-content>
											<v-list-item-title>
												<v-row no-gutters>
													{{ingredient.product.name}}
													<template v-if="ingredient.processing">
														<span class="mx-1">|</span>
														<span>{{ingredient.processing.name}}</span>
														<span class="ml-1" v-if="ingredient.info">({{ingredient.info}})</span>
													</template>
													<v-spacer></v-spacer>
													{{ingredient.quantity}} {{ingredient.unit}}
												</v-row>
											</v-list-item-title>
											<v-list-item-subtitle v-if="ingredient.product.scientific_name">
												<span
													class="font-italic"
												>{{ingredient.product.scientific_name.charAt(0).toUpperCase() + ingredient.product.scientific_name.slice(1)}}</span>
											</v-list-item-subtitle>
											<v-row no-gutters v-if="ingredient.ingredients.length > 0">
												<v-col
													cols="12"
													no-gutters
													class="ma-0 pl-4"
													v-for="(ingredient, index) in ingredient.ingredients"
													:key="index"
												>
													<v-row no-gutters>
														<span class="text-caption">{{ingredient.product.name}}</span>
														<v-spacer></v-spacer>
														<span
															v-if="ingredient.quantity > 0"
															class="text-caption"
														>{{ingredient.quantity}} {{ingredient.unit}}</span>
													</v-row>
												</v-col>
											</v-row>
										</v-list-item-content>
									</v-list-item>
									<!-- <p :class="ingredient.ingredients.length > 0 ? 'mb-0' : ''">
											{{ingredient.name}}
											<template v-if="ingredient.processing">
												|<span>
													{{ingredient.processing.name}}
												</span>
												<span v-if="ingredient.info">
													({{ingredient.info}})
												</span>
											</template>
											{{ingredient.quantity}} {{ingredient.unit}}
										</p>
										<div class="mb-3" v-if="ingredient.ingredients.length > 0">
											<p class="ma-0 ml-2" v-for="(ingredient, index) in ingredient.ingredients" :key="index">
												- {{ingredient.name}}
												<span v-if="ingredient.quantity > 0">
													({{ingredient.quantity}} {{ingredient.unit}})
												</span>
											</p>
									</div>-->
								</div>
							</template>
						</v-col>
						<v-col v-else cols="12" md="12">
							<v-row no-gutters>
								<v-col cols="6">
									<h3 class="my-4 primary--text" v-translate>Components</h3>
								</v-col>
								<v-col cols="6">
									<h3 class="my-4 primary--text" v-translate>Recommended Posology</h3>
								</v-col>
								<p
									v-if="ingredients.length === 0"
									class="font-weight-thin ml-2"
									v-translate
								>No components specified.</p>
								<template v-else>
									<v-row no-gutters v-for="(ingredient, index) in ingredients" :key="index">
										<v-col cols="6">
											<v-card class="ma-1" outlined>
												<v-simple-table>
													<template v-slot:default>
														<thead>
															<tr>
																<th class="text-left" v-translate key="presentation">Presentation</th>
																<th class="text-left" v-translate key="storage">Storage</th>
																<th class="text-left" v-translate key="unit">Unit</th>
																<th class="text-left" v-translate key="units">Units p/ box</th>
															</tr>
														</thead>
														<tbody>
															<tr>
																<td>
																	<span v-if="ingredient.presentation">{{ ingredient.presentation.name }}</span>
																	<span v-else v-translate>Not defined</span>
																</td>
																<td>
																	<span v-if="ingredient.storage">{{ ingredient.storage.name }}</span>
																	<span v-else v-translate>Not defined</span>
																</td>
																<td>
																	<span
																		v-if="ingredient.unit"
																	>{{ ingredient.unit.name }} ({{ ingredient.unit.code }})</span>
																	<span v-else v-translate>Not defined</span>
																</td>
																<td>
																	<span v-if="ingredient.units_box">{{ ingredient.units_box }}</span>
																	<span v-else v-translate>Not defined</span>
																</td>
															</tr>
														</tbody>
													</template>
												</v-simple-table>
												<v-row no-gutters class="my-2 px-2" justify="center" align="center">
													<span class="primary--text" v-translate>Ingredients</span>
													<v-spacer></v-spacer>
													<span
														v-if="ingredient.ingredients.length > 0 && ingredient.unit"
														class="text-caption"
													>Quantidade por {{ingredient.daily_dose}} {{ingredient.unit.code}}</span>
												</v-row>
												<div v-for="(ingredient, index) in ingredient.ingredients" :key="index">
													<v-list-item dense>
														<v-list-item-content>
															<v-list-item-title>
																<v-row no-gutters>
																	{{ingredient.product.name}}
																	<template v-if="ingredient.processing">
																		<span class="mx-1">|</span>
																		<span>{{ingredient.processing.name}}</span>
																		<span class="ml-1" v-if="ingredient.info">({{ingredient.info}})</span>
																	</template>
																	<v-spacer></v-spacer>
																	{{ingredient.quantity}} {{ingredient.unit}}
																</v-row>
															</v-list-item-title>
															<v-list-item-subtitle v-if="ingredient.product.scientific_name">
																<span
																	class="font-italic"
																>{{ingredient.product.scientific_name.charAt(0).toUpperCase() + ingredient.product.scientific_name.slice(1)}}</span>
															</v-list-item-subtitle>
															<v-row no-gutters v-if="ingredient.ingredients.length > 0">
																<v-col
																	cols="12"
																	no-gutters
																	class="ma-0 pl-4"
																	v-for="(ingredient, index) in ingredient.ingredients"
																	:key="index"
																>
																	<v-row no-gutters>
																		<span class="text-caption">{{ingredient.product.name}}</span>
																		<v-spacer></v-spacer>
																		<span
																			v-if="ingredient.quantity > 0"
																			class="text-caption"
																		>{{ingredient.quantity}} {{ingredient.unit}}</span>
																	</v-row>
																</v-col>
															</v-row>
														</v-list-item-content>
													</v-list-item>
												</div>
											</v-card>
										</v-col>
										<v-col cols="6">
											<v-card class="ma-1" outlined>
												<v-simple-table
													v-if="existPosologyRecommendationComplex(ingredient.recommendation_quantity)"
												>
													<template v-slot:default>
														<thead>
															<tr>
																<th class="text-left" v-translate>M</th>
																<th class="text-left" v-translate>MM</th>
																<th class="text-left" v-translate>HD</th>
																<th class="text-left" v-translate>MA</th>
																<th class="text-left" v-translate>N</th>
															</tr>
														</thead>
														<tbody>
															<tr>
																<td>{{ingredient.recommendation_quantity.morning}}</td>
																<td>{{ingredient.recommendation_quantity.middle_morning}}</td>
																<td>{{ingredient.recommendation_quantity.half_day}}</td>
																<td>{{ingredient.recommendation_quantity.middle_afternoon}}</td>
																<td>{{ingredient.recommendation_quantity.night}}</td>
															</tr>
														</tbody>
													</template>
												</v-simple-table>
												<template v-if="existPosologyLimitsComplex(ingredient.recommendation_quantity)">
													<p class="mb-0 mt-2 ml-2">
														<strong v-translate>Limits</strong>
													</p>
													<v-simple-table>
														<template v-slot:default>
															<thead>
																<tr></tr>
															</thead>
															<tbody>
																<tr v-if="ingredient.recommendation_quantity.over16 != ''">
																	<td class="font-weight-bold">
																		>16
																		<translate>years</translate>
																	</td>
																	<td>{{ingredient.recommendation_quantity.over16}}</td>
																</tr>
																<tr v-if="ingredient.recommendation_quantity.between12_15 != ''">
																	<td class="font-weight-bold">
																		12-15
																		<translate>years</translate>
																	</td>
																	<td>{{ingredient.recommendation_quantity.between12_15}}</td>
																</tr>
																<tr v-if="ingredient.recommendation_quantity.between6_11 != ''">
																	<td class="font-weight-bold">
																		6-11
																		<translate>years</translate>
																	</td>
																	<td>{{ingredient.recommendation_quantity.between6_11}}</td>
																</tr>
																<tr v-if="ingredient.recommendation_quantity.under6 != ''">
																	<td class="font-weight-bold">
																		6
																		<translate>years</translate>
																	</td>
																	<td>{{ingredient.recommendation_quantity.under6}}</td>
																</tr>
																<tr v-if="ingredient.recommendation_quantity.pos_pregnant != ''">
																	<td class="font-weight-bold" v-translate>Pregnant</td>
																	<td>{{ingredient.recommendation_quantity.pos_pregnant}}</td>
																</tr>
																<tr v-if="ingredient.recommendation_quantity.pos_lactant != ''">
																	<td class="font-weight-bold" v-translate>Lactant</td>
																	<td>{{ingredient.recommendation_quantity.pos_lactant}}</td>
																</tr>
															</tbody>
														</template>
													</v-simple-table>
												</template>
											</v-card>
											<p
												v-if="!existPosologyRecommendationComplex(ingredient.recommendation_quantity) && !existPosologyLimitsComplex(ingredient.recommendation_quantity)"
												class="font-weight-thin ml-2"
												v-translate
											>No recommended posology.</p>
										</v-col>
									</v-row>
								</template>
							</v-row>
						</v-col>
						<v-col v-if="!product.product.complex_product" cols="12" md="6">
							<h3 class="my-4 primary--text" v-translate>Recommended Posology</h3>
							<v-simple-table v-if="existPosologyRecommendation">
								<template v-slot:default>
									<thead>
										<tr>
											<th class="text-left" v-translate>M</th>
											<th class="text-left" v-translate>MM</th>
											<th class="text-left" v-translate>HD</th>
											<th class="text-left" v-translate>MA</th>
											<th class="text-left" v-translate>N</th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<td>{{recommendation_quantity.morning}}</td>
											<td>{{recommendation_quantity.middle_morning}}</td>
											<td>{{recommendation_quantity.half_day}}</td>
											<td>{{recommendation_quantity.middle_afternoon}}</td>
											<td>{{recommendation_quantity.night}}</td>
										</tr>
									</tbody>
								</template>
							</v-simple-table>
							<template v-if="existPosologyLimits">
								<p class="mb-0 mt-2">
									<strong v-translate>Limits</strong>
								</p>
								<v-simple-table>
									<template v-slot:default>
										<thead>
											<tr></tr>
										</thead>
										<tbody>
											<tr v-if="recommendation_quantity.over16 != ''">
												<td class="font-weight-bold">
													>16
													<translate>years</translate>
												</td>
												<td>{{recommendation_quantity.over16}}</td>
											</tr>
											<tr v-if="recommendation_quantity.between12_15 != ''">
												<td class="font-weight-bold">
													12-15
													<translate>years</translate>
												</td>
												<td>{{recommendation_quantity.between12_15}}</td>
											</tr>
											<tr v-if="recommendation_quantity.between6_11 != ''">
												<td class="font-weight-bold">
													6-11
													<translate>years</translate>
												</td>
												<td>{{recommendation_quantity.between6_11}}</td>
											</tr>
											<tr v-if="recommendation_quantity.under6 != ''">
												<td class="font-weight-bold">
													6
													<translate>years</translate>
												</td>
												<td>{{recommendation_quantity.under6}}</td>
											</tr>
											<tr v-if="recommendation_quantity.pos_pregnant != ''">
												<td class="font-weight-bold" v-translate>Pregnant</td>
												<td>{{recommendation_quantity.pos_pregnant}}</td>
											</tr>
											<tr v-if="recommendation_quantity.pos_lactant != ''">
												<td class="font-weight-bold" v-translate>Lactant</td>
												<td>{{recommendation_quantity.pos_lactant}}</td>
											</tr>
										</tbody>
									</template>
								</v-simple-table>
							</template>
							<p
								v-if="!existPosologyRecommendation && !existPosologyLimits"
								class="font-weight-thin ml-2"
								v-translate
							>No recommended posology.</p>
						</v-col>
					</v-row>
					<v-row no-gutters>
						<v-col cols="12" md="6">
							<h3 class="my-4 primary--text" v-translate>Indications</h3>
							<p
								v-if="indications.length === 0"
								class="font-weight-thin ml-2"
								v-translate
							>No indications specified.</p>
							<template v-else>
								<p v-for="(indication, index) in indications" :key="index">- {{indication.title}}</p>
							</template>
						</v-col>
						<v-col cols="12" md="6">
							<h3 class="my-4 red--text" v-translate>Contra-Indications</h3>
							<p
								v-if="contraindications.length === 0"
								class="font-weight-thin ml-2"
								v-translate
							>No contra-indications specified.</p>
							<template v-else>
								<p
									v-for="(contraindication, index) in contraindications"
									:key="index"
								>- {{contraindication.title}}</p>
							</template>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-text v-if="!loadingProductInfo && type === 'formula'">
					<template v-if="!product.product.classic">
						<h3
							v-if="!product.product.from_lab"
							class="primary--text mt-3"
							v-translate
						>Custom Formula Info</h3>
						<h3 v-else class="primary--text mt-3" v-translate>Formula Info</h3>
						<v-simple-table v-if="product.product.from_lab">
							<template v-slot:default>
								<thead>
									<tr>
										<th class="text-left" v-translate>Name</th>
										<th class="text-left" v-translate>Provider</th>
										<th class="text-left" v-translate>Formula Provider ID</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>{{ product.product.name }}</td>
										<td>{{ product.product.external_entity }}</td>
										<td>{{ product.product.lab_formula_id }}</td>
									</tr>
								</tbody>
							</template>
						</v-simple-table>
						<v-simple-table v-if="ingredients.length > 0">
							<template v-slot:default>
								<thead>
									<tr>
										<th class="text-left" v-translate>Substance</th>
										<th class="text-left" v-translate>Quantity (g)</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="ingredient in ingredients" :key="ingredient.name">
										<td>{{ ingredient.name }}</td>
										<td>{{ ingredient.quantity }}</td>
									</tr>
								</tbody>
							</template>
						</v-simple-table>
					</template>
					<h3 class="primary--text mt-3" v-translate>Classic Formula Info</h3>
					<v-simple-table>
						<template v-slot:default>
							<thead>
								<tr>
									<th class="text-left" v-translate>Name</th>
									<th class="text-left" v-translate>Translation</th>
									<th class="text-left" v-translate>Sub-Category</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>{{ product.product.name }}</td>
									<td>{{ product.product.translation }}</td>
									<td>{{ product.product.sub_category }}</td>
								</tr>
							</tbody>
						</template>
					</v-simple-table>
					<template v-if="product.product.pattern">
						<h4 class="mt-3" v-translate>Pattern</h4>
						<p>{{product.product.pattern}}</p>
					</template>
					<template v-if="product.product.actions">
						<h4 v-translate>Actions</h4>
						<p>{{product.product.actions}}</p>
					</template>
					<template v-if="product.product.tongue">
						<h4 v-translate>Possible Tongue Appearance</h4>
						<p>{{product.product.tongue}}</p>
					</template>
					<template v-if="product.product.pulse">
						<h4 v-translate>Possible Pulse Appearance</h4>
						<p>{{product.product.pulse}}</p>
					</template>
					<template v-if="product.product.prep_notes">
						<h4 v-translate>Preparation Notes</h4>
						<p>{{product.product.prep_notes}}</p>
					</template>
					<template v-if="product.product.original">
						<h4 v-translate>Originally Appeared In</h4>
						<p>{{product.product.original}}</p>
					</template>
					<template v-if="product.product.channels">
						<h4 v-translate>Combined Channels of all herbs in this formula</h4>
						<p>{{product.product.channels}}</p>
					</template>
					<template v-if="product.product.western_uses">
						<h4 v-translate>Western Uses</h4>
						<p>{{product.product.western_uses}}</p>
					</template>
					<template v-if="product.product.notes">
						<h4 v-translate>Aditional Notes</h4>
						<p>{{product.product.notes}}</p>
					</template>
					<template v-if="product.product.temperature">
						<h4 v-translate>Temperature</h4>
						<p>{{product.product.temperature}}</p>
					</template>
					<h3 class="primary--text mt-3" v-translate>Substances</h3>
					<h4 class="mt-3">
						<translate>Total Number of Substances</translate>
						:
						{{product.product.num_substances}}
					</h4>
					<template v-if="ingredients.length > 0">
						<h4 class="mt-3" v-translate>List of Substances:</h4>
						<p v-for="ing in ingredients" :key="ing.id" class="my-0 ml-2">{{ing.name}}</p>
					</template>
					<v-row no-gutters>
						<v-col cols="12" md="6">
							<h3 class="my-4 primary--text" v-translate>Indications</h3>
							<p
								v-if="indications.length === 0"
								class="font-weight-thin ml-2"
								v-translate
							>No indications specified.</p>
							<p v-for="(indication, index) in indications" :key="index">- {{indication.title}}</p>
						</v-col>
						<v-col cols="12" md="6">
							<h3 class="my-4 red--text" v-translate>Contra-Indications</h3>
							<p
								v-if="contraindications.length === 0"
								class="font-weight-thin ml-2"
								v-translate
							>No contra-indications specified.</p>
							<p
								v-for="(contraindication, index) in contraindications"
								:key="index"
							>- {{contraindication.title}}</p>
						</v-col>
					</v-row>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary darken-1" text @click="showProductInfo = false">
						<translate>Close</translate>
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-chip>
</template>

<script>
import axios from "axios";

export default {
	name: "ProductItemHistory",
	props: ["product", "type"],
	data: () => ({
    showProductInfo: false,
    loadingProductInfo: true,
    recommendation_quantity: {},
		ingredients: [],
		indications: [],
		contraindications: []
  }),
  computed: {
    existPosologyRecommendation() {
			if(this.recommendation_quantity.morning != 0 ||
			this.recommendation_quantity.middle_morning != 0 ||
			this.recommendation_quantity.half_day != 0 ||
			this.recommendation_quantity.middle_afternoon != 0 ||
			this.recommendation_quantity.night != 0) return true
			else return false
		},
		existPosologyLimits() {
			if(this.recommendation_quantity.over16 != '' ||
			this.recommendation_quantity.between12_15 != '' ||
			this.recommendation_quantity.between6_11 != '' ||
			this.recommendation_quantity.under6 != '' ||
			this.recommendation_quantity.pos_pregnant != '' ||
			this.recommendation_quantity.pos_lactant != '') return true
			else return false
		}
  },
  methods: {
    getProductInfo() {
			if (this.loadingProductInfo) {
				//CALL API
				var link = "";
				if (this.type === "supplement") link = "/product/";
				else link = "/mtc/formulas/";
				axios
					.get(link + this.product.product.id + "/info", {params: { complete: true}})
					.then(response => {
						if (response.status === 200) {
              console.log(response.data);
							if (this.type === "supplement") {
                this.product.product = response.data.product;
								this.recommendation_quantity =
									response.data.recommendation_quantity;
							}
							this.ingredients = response.data.ingredients;
							this.indications = response.data.indications;
							this.contraindications = response.data.contraindications;
              this.loadingProductInfo = false;
              this.showProductInfo = true;
						}
					})
					.catch(error => {
						console.log(error);
						this.loadingProductInfo = false;
					});
      } else {
        this.showProductInfo = true;
      }
		}
  }
};
</script>